export let dayOfWeek = [
    'Sonntag',
    'Montag',
    'Dienstag',
    'Mittwoch',
    'Donnerstag',
    'Freitag',
    'Samstag',
];

export function formatDateHuman(d) {
    return `${pad(d.getDate())}.${pad(d.getMonth() + 1)}.${d.getFullYear()}`;
}

export function formatDateApi(d) {
    return `${d.getFullYear()}-${pad(d.getMonth() + 1)}-${pad(d.getDate())}`;
}

export function parseDateApi(d) {
    return new Date(d);
}

function pad(s, len = 2) {
    s = '' + s;
    while (s.length < len) {
        s = '0' + s;
    }
    return s;
}
